import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArticleContainerComponent } from './article-container/article-container.component';
import {
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarModule
} from 'ngx-perfect-scrollbar';
import { CardsModule } from '../cards/cards.module';
import { ListCardContentModule } from '../list-card-content/list-card-content.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ArticleContainerComponent],
  exports: [ArticleContainerComponent],
  imports: [
    CommonModule,
    CardsModule,
    PerfectScrollbarModule,
    ListCardContentModule,
    TranslateModule
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: {}
    }
  ]
})
export class ArticleContainerModule {}
